import PoDetail from '@/store/modules/poDetails/constants';

export default {
  [PoDetail.mutationTypes.setPoNumber](state, poNumber) {
    const localState = state;

    localState.poNumber = poNumber;
  },

  [PoDetail.mutationTypes.setCurrentLineItemId](state, id) {
    const localState = state;

    localState.currentLineItemId = id;
  },

  [PoDetail.mutationTypes.setCurrentGroupLineItemNumber](state, number) {
    const localState = state;

    localState.currentGroupLineItemNumber = number;
  },

  [PoDetail.mutationTypes.setPoLineItems](state, items) {
    const localState = state;

    localState.lineItems = items;
  },

  [PoDetail.mutationTypes.setPoGroupedLineItems](state, items) {
    const localState = state;

    localState.groupedLineItems = items;
  },

  [PoDetail.mutationTypes.setUploadedImagesLoading](state, loading) {
    const localState = state;

    localState.uploadedImagesLoading = loading;
  },

  [PoDetail.mutationTypes.setApprovedImagesLoading](state, loading) {
    const localState = state;

    localState.approvedImagesLoading = loading;
  },

  [PoDetail.mutationTypes.setActivityLoading](state, loading) {
    const localState = state;

    localState.activityLoading = loading;
  },

  [PoDetail.mutationTypes.setLoading](state, loading) {
    const localState = state;

    localState.loading = loading;
  },

  [PoDetail.mutationTypes.setCurrentLineItemUploadedImages](state, images) {
    const localState = state;

    localState.currentLineItemUploadedImages = images;
  },

  [PoDetail.mutationTypes.setCurrentLineItemApprovedImages](state, images) {
    const localState = state;

    localState.currentLineItemApprovedImages = images;
  },

  [PoDetail.mutationTypes.setCurrentLineItemActivity](state, activities) {
    const localState = state;

    localState.currentLineItemActivities = activities;
  },

  [PoDetail.mutationTypes.setCurrentLineItemActivityCanAddComment](state, canAddComment) {
    const localState = state;

    localState.canAddComment = canAddComment;
  },

  [PoDetail.mutationTypes.setCurrentLineItemActivityIsAssignedToClient](state, isAssignedToClient) {
    const localState = state;

    localState.isAssignedToClient = isAssignedToClient;
  },

  [PoDetail.mutationTypes.setClients](state, clientInfo) {
    const localState = state;

    localState.clients = clientInfo.clients;
    localState.isMyClient = clientInfo.isMyClient;
    localState.isMyEmployeeClient = clientInfo.isMyEmployeeClient;
  },

  [PoDetail.mutationTypes.setImagesUploading](state, isUploading) {
    const localState = state;

    localState.imagesUploading = isUploading;
  },

  [PoDetail.mutationTypes.setActionsDisabled](state, isDisabled) {
    const localState = state;

    localState.actionsDisabled = isDisabled;
  },

  [PoDetail.mutationTypes.searchFinished](state, searchResult) {
    state.searchResults = searchResult;
  },

  [PoDetail.mutationTypes.clearResults](state) {
    state.searchResults = null;
  },

  [PoDetail.mutationTypes.changeNumberOfBoxes](state, { id, numberOfBoxes }) {
    const currentLineItem = state.groupedLineItems
      .find(li => li.itemNumber === state.currentGroupLineItemNumber);
    const sku = currentLineItem.lineItems.find(li => li.id === id);

    if (sku.boxes.length > numberOfBoxes) {
      sku.boxes = sku.boxes.slice(0, numberOfBoxes);
    } else {
      for (let i = sku.boxes.length; i < numberOfBoxes; i += 1) {
        sku.boxes.push({
          quantity: 1,
          quantityInput: '1',
          sscc: '',
        });
      }
    }
  },

  [PoDetail.mutationTypes.changeBox](state, {
    id, boxIndex, path, value,
  }) {
    const currentLineItem = state.groupedLineItems
      .find(li => li.itemNumber === state.currentGroupLineItemNumber);
    const sku = currentLineItem.lineItems.find(li => li.id === id);
    const newBoxes = [...sku.boxes];
    newBoxes[boxIndex] = {
      ...newBoxes[boxIndex],
      [path]: value,
    };
    sku.boxes = newBoxes;
  },
};
